import TIM from 'tim-js-sdk';
import { GetMessageListProps } from '@shared/common/helper/type-tim-sdk';

export class ConversationManger {
  tim: TIM.IMClient;
  constructor(tim: TIM.IMClient) {
    this.tim = tim;
  }

  /** 获取消息列表 */
  async getMessageList({ conversationID, nextReqMessageID, count }: GetMessageListProps) {
    const resp = await this.tim.getMessageList({ conversationID, nextReqMessageID, count });
    return resp.data;
  }

  /** 获取会话列表 */
  async getConversationList({ conversationID }: { conversationID?: string[] }) {
    const resp = await this.tim.getConversationList(conversationID);
    return resp.data;
  }

  /** 将某个会话的未读消息设置为已读 */
  async setReadMessage({ conversationID }: { conversationID: string }) {
    await this.tim.setMessageRead({ conversationID });
  }
}
